let e, o = {};
const t = (l) => {
  e = l.logger, o = l.callbacks || {};
};
export {
  o as callbacks,
  t as initConfig,
  e as logger
};
